import React from "react";
import LegalCheckIcon from "./LegalCheckIcon";

interface LegalListItemProps {
  children: React.ReactNode;
}

/**
 * Single list item matching pricing page style
 */
const LegalListItem: React.FC<LegalListItemProps> = ({ children }) => (
  <li>
    <span><LegalCheckIcon /></span>
    <span>{children}</span>
  </li>
);

export default LegalListItem;
